module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/craters_layer_on-5300c17fec09568b8ff71ad2a819053f.png";